import { defineStore } from 'pinia'
import { AsyncOperationState } from './lib/AsyncOperationState'
import { loadProductSearchResults } from '@/services/productSearch'
import type { Product } from '@/services/product'
import Bugsnag from '@bugsnag/js'

export const useProductSearchStore = defineStore('productSearch', {
  state: () => ({
    query: '',
    loadState: AsyncOperationState.IDLE,
    results: [] as Product[],
  }),
  actions: {
    async setQuery(q: string) {
      this.query = q
      if (q.length < 3) {
        this.loadState = AsyncOperationState.IDLE
        this.results = []
        return
      }
      this.loadState = AsyncOperationState.IN_PROGRESS
      try {
        const res = await loadProductSearchResults(this.query)
        this.results = res.data.search.edges.map((edge) => edge.node)
        this.loadState = AsyncOperationState.DONE
      } catch (e) {
        this.loadState = AsyncOperationState.ERRORED
        Bugsnag.notify(e as Error)
      }
    },
  },
})
